export const ALERT_TYPE = {
	MACHINE_WITHOUT_SALES: 'machine_without_sales',
	DEVICE_DISCONNECTED: 'device_disconnected',
	SOAP_ALERT: 'soap_alert',
	DEVICE_OUT_OF_SERVICE: 'device_out_of_service',
	PAYMENT_INACTIVE: 'payment_inactive',
} as const;

export type AlertType = (typeof ALERT_TYPE)[keyof typeof ALERT_TYPE];

// Whether an alert's points of sale are chosen: always, optionally (none chosen means all), or never.
export type MachinesMode = 'required' | 'optional' | 'none';

export const ALERT_TYPE_MACHINES: Record<AlertType, MachinesMode> = {
	[ALERT_TYPE.MACHINE_WITHOUT_SALES]: 'required',
	[ALERT_TYPE.DEVICE_DISCONNECTED]: 'optional',
	[ALERT_TYPE.SOAP_ALERT]: 'none',
	[ALERT_TYPE.DEVICE_OUT_OF_SERVICE]: 'optional',
	[ALERT_TYPE.PAYMENT_INACTIVE]: 'optional',
};

export const ALERT_TYPES = Object.values(ALERT_TYPE);

export const HOURS_WITHOUT_SALES = 3;

// A «Sin ventas» alert starting today may fire as soon as it is saved, so the user confirms it.
export const firesOnSave = (alertType: AlertType, startDate: string | undefined, today: string) =>
	alertType === ALERT_TYPE.MACHINE_WITHOUT_SALES && startDate === today;

export type AlertStep = 'type' | 'machines' | 'details' | 'schedule';

export const getAlertSteps = (type: AlertType | undefined): AlertStep[] => {
	if (type === ALERT_TYPE.MACHINE_WITHOUT_SALES) return ['type', 'machines', 'details', 'schedule'];
	if (type && ALERT_TYPE_MACHINES[type] !== 'none') return ['type', 'machines', 'details'];
	return ['type', 'details'];
};
